import $ from "jquery";

//テキストを一文字ずつ円形に配置する ※動きはCSSアニメーション//
const before = $(".js-rotate-text");
const text = before.text();
const textArray = text.split("");

let after = "";
$.each(textArray, function (index, val) {
  after += "<span>" + val + "</span>";
});
before.html(after);

//ブラウザサイズに応じた円を作る
const textcnt = textArray.length;

function rotateItem() {
  const circleR = $(".js-rotate-wrapper").height() / 2;
  const fontH = $(".js-rotate").height();
  const dist = circleR - fontH;
  $(".js-rotate-text span").each(function (index) {
    const num = index + 1;
    const radX = Math.sin((360 / textcnt) * num * (Math.PI / 180));
    const radY = Math.sin((90 - (360 / textcnt) * num) * (Math.PI / 180));
    $(this).css(
      "transform",
      "translate(" +
        dist * radX +
        "px, " +
        -(dist * radY) +
        "px) rotate(" +
        (360 / textcnt) * num +
        "deg)"
    );
  });
}
//ページが表示されたときにrotateItemを呼び出す
$(function () {
  rotateItem();
});
//リサイズされたときにrotateItemを呼び出す
window.addEventListener("resize", rotateItem);
